import axios from 'axios';

const API_BASE_URL = 'https://bingchongweb-api.d.agriai.cc';

/**
 * 调用对话式诊断接口
 * @param {Array} history - 对话历史数组
 * @param {Boolean} stream - 是否使用流式响应，默认为false
 * @param {String} language - 语言代码 "zh" 或 "en"
 * @returns {Promise} 包含对话响应的Promise
 */
export async function cropDiagnosis(history, stream = false, language = 'zh') {
  const response = await axios.post(`${API_BASE_URL}/api/v1/crop-diagnosis?language=${language}`, {
    history,
    stream
  });
  
  return response.data;
}

/**
 * 调用疾病识别接口
 * @param {File} imageFile - 要分析的作物图片文件
 * @param {string} cropName - 作物名称
 * @param {String} language - 语言代码 "zh" 或 "en"
 * @returns {Promise} 包含识别结果的Promise
 */
export async function predictDisease(imageFile, cropName, language = 'zh') {
  // 创建FormData
  const formData = new FormData();
  formData.append('file', imageFile);
  formData.append('name', cropName);
  
  // 发送请求并返回结果
  const response = await axios.post(`${API_BASE_URL}/predict?language=${language}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  // 添加cropName字段到返回数据中
  return {
    ...response.data,
    cropName
  };
}

export default {
  cropDiagnosis,
  predictDisease
}
